import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { DsLoadingModule } from '@bmw-ds/components';

import { InputFieldComponent } from '../../../form/components/input-field/input-field.component';
import { useI18n } from '../../../i18n/services/i18n.service';
import { SearchButtonComponent } from '../search-button/search-button.component';

@Component({
  selector: 'cdf-form-search-for-licence',
  imports: [InputFieldComponent, SearchButtonComponent, DsLoadingModule],
  host: { class: 'd-flex flex-column gap-2x' },
  template: `
    <h3>{{ i18n('headings.searchForLicence') }}</h3>

    <div class="d-flex gap-2x">
      <cdf-input-field
        id="licence-number"
        [placeholder]="i18n('placeholder.licenceNumber')"
        [(model)]="licenceNumber"
      />
      <cdf-search-button
        ds-loading
        id="search-licence-button"
        [disabled]="!licenceNumber()"
        [isLoading]="saving()"
        (searchClick)="searchLicence.emit()"
        [label]="i18n('placeholder.licenceNumber')"
      />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSearchForLicenceComponent {
  readonly i18n = useI18n();

  readonly licenceNumber = model.required<string | undefined>();
  readonly saving = input(false);
  readonly searchLicence = output();
}
